<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of Cities/Towns</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New City/Town"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>

        <CitiesTownsTable
          :key="citiesTownsKey"
          :citiesTowns="citiesTowns"
          :loading="loading"
          :filters="filters"
          @edit-city-town="editCityTown"
          @delete-city-town="deleteCityTown"
        />

        <CitiesTownsForm
          :citiesTownsToEdit="cityTown"
          :key="citiesTownsFormKey"
          :citiesTownsForm="citiesTownsForm"
          :sendingRequest="sendingRequest"
          :disabledArr="disabledArr"
          @close="cityTown = {}, citiesTownsForm = false"
          @save="saveCityTown"
        />

      </div>
    </div>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import CitiesTownsTable from './CitiesTownsTable'
import CitiesTownsForm from './CitiesTownsForm'

export default {
  components: {
    CitiesTownsTable,
    CitiesTownsForm
  },
  data: () => ({
    customerService: new CustomerService(),
    filters: '',
    citiesTownsKey1: 0,
    citiesTowns: [],
    citiesTownsForm: false,
    citiesTownsFormKey1: 0,
    disabledArr: [],
    cityTown: {},
    requesting: false,
    sendingRequest: false
  }),
  computed: {
    citiesTownsKey: {
      set(val) {
        this.citiesTownsKey1++
      },
      get() {
        return 'CitiesTownsTable' + this.citiesTownsKey1.toString()
      }
    },
    citiesTownsFormKey: {
      set(val) {
        this.citiesTownsFormKey1++
      },
      get() {
        return 'CitiesTownsForm' + this.citiesTownsFormKey1.toString()
      }
    },
    loading() {
      if (this.citiesTowns && this.citiesTowns[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllCitiesTownsByHard()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    filters(val) {
      this.jobFunctionsKey++
    },
    citiesTownsForm(val) {
      this.citiesTownsFormKey++
    },
    citiesTowns(val) {
      if (val && Array.isArray(val)) {
        this.citiesTownsKey++
      }
    }
  },
  methods: {
    deleteCityTown(cityTown) {
      if (cityTown && cityTown.id) {
        this.customerService
          .deleteCityTown(cityTown.id)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "City/Town deleted",
              detail: "City/Town updated deleted.",
              life: 5000,
            });
          
            this.citiesTownsForm = false
            this.getAllCitiesTownsByHard()
            this.getAllActiveCitiesTownsByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while deleting City/Town",
              life: 5000,
            })
          })
      }
    },
    editCityTown(cityTown) {
      
      this.cityTown = cityTown
      this.citiesTownsForm = true
    },
    saveCityTown(cityTown) {
      

      this.sendingRequest = true

      if (cityTown.id) {
        delete cityTown.colourCode

        this.customerService
          .editCityTown(cityTown)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "City/Town updated",
              detail: "City/Town updated successfully.",
              life: 5000,
            });
          
            this.sendingRequest = false
            this.citiesTownsForm = false
            this.getAllCitiesTownsByHard()
            this.getAllActiveCitiesTownsByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating City/Town",
              life: 5000,
            })
          })
      } else {
        this.customerService
          .saveCityTown(cityTown)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "City/Town saved",
              detail: "City/Town saved successfully.",
              life: 5000,
            })
          
            this.sendingRequest = false
            this.citiesTownsForm = false
            this.getAllCitiesTownsByHard()
            this.getAllActiveCitiesTownsByHard()
          })
          .catch(err => {
            this.sendingRequest = false
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving City/Town",
              life: 5000,
            })
          })
      }
    },
    getAllCitiesTownsByHard() {
      this.requesting = true
      this.customerService
        .getAllCitiesTownsByHard()
        .then(data => {
          this.requesting = false
          this.citiesTowns = data
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting activity results",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "citiesTowns"'
          })
        })
    },
    getAllActiveCitiesTownsByHard() {
      this.customerService
        .getAllActiveCitiesTownsByHard()
        .then(data => {})
        .catch(err => {
          
                
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "citiesTowns"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.cityTown = {}
      this.citiesTownsForm = true
    }
  }
}
</script>

<style>

</style>